import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormGroup,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  InvoiceControlConfiguration,
  DynamicControlConfiguration,
} from '../../interfaces/dynamic-form-controls';

@Component({
  selector: 'app-invoice-form-control',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  template: `
    <div [formGroup]="formGroup">
      <label
        *ngIf="showLabel && config.displayName"
        [for]="config.name"
        class="block whitespace-nowrap"
      >
        {{ config.displayName }}
        <span class="text-red-600" *ngIf="config.reqiuired">*</span>
      </label>
      <input
        [id]="config.name"
        [formControlName]="config.name"
        type="text"
        placeholder="YY01000001"
        maxlength="10"
        class="border border-gray-300 rounded px-3 py-2 w-full"
        (input)="onInputChange($event)"
      />
      <div class="">
        <small
          class="text-red-700"
          *ngIf="
            formGroup?.get(config.name)?.hasError('required') &&
            formGroup.get(config.name)?.touched
          "
        >
          {{ config.displayName }} är obligatoriskt
        </small>
        <small
          class="text-red-700"
          *ngIf="
            formGroup?.get(config.name)?.hasError('invalidInvoiceFormat') &&
            formGroup.get(config.name)?.touched
          "
        >
          Fakturanummer måste vara i formatet YY01000001 (t.ex. 2501000001)
        </small>
      </div>
    </div>
  `,
  styles: [],
})
export class InvoiceFormControlComponent {
  @Input() showLabel = true;

  @Input('config') input!: DynamicControlConfiguration;
  get config(): InvoiceControlConfiguration {
    return this.input as InvoiceControlConfiguration;
  }

  formGroupDirective = inject(FormGroupDirective);
  get formGroup(): FormGroup {
    return this.formGroupDirective.form;
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Remove non-digits

    // Limit to 10 digits
    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    // Update the form control value
    this.formGroup.get(this.config.name)?.setValue(value);
  }
}
